<template>
  <v-dialog v-if="show" v-model="show" persistent width="60%">
    <v-card color="cardbg">
      <v-card-title class="headline text-xs-center font-weight-bold">{{
        $t("hfManagement.showEquipmentTitle")
      }}</v-card-title>
      <v-card-text>
        <v-data-table
          class="elevation-1 equipment-table"
          mobile-breakpoint="0"
          :headers="equipmentTableHeaders"
          :items="equipmentList"
          hide-default-footer
        >
          <template v-slot:item="machineryList">
            <tr class="table-row text-xs-center">
              <td class="table-data body-1 font-weight-bold">
                {{
                  $t(`hfManagement.equipmentTable.${machineryList.item.name}`)
                }}
              </td>
              <td class="table-data body-1 font-weight-bold text-center">
                {{ machineryList.item.total }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-spacer></v-spacer>
        <v-btn
          class="px-4 caption font-weight-bold"
          color="primary"
          rounded
          depressed
          @click="show = false"
          >{{ $t("closeButton") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      equipmentTableHeaders: [
        {
          text: this.$i18n.t("hfManagement.equipmentTable.machinery"),
          sortable: false,
          align: "left"
        },
        {
          text: this.$i18n.t("hfManagement.equipmentTable.total"),
          sortable: false
        }
      ]
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    officeEquipment() {
      return this.$store.getters["machinery/officeEquipment"];
    },
    equipmentTableKeys() {
      return this.$store.getters["machinery/equipmentTableKeys"];
    },
    equipmentList() {
      const equipmentItems = this.officeEquipment.equipment;
      const filteredEquipmentList = Object.keys(equipmentItems)
        .filter(key => this.equipmentTableKeys.includes(key))
        .reduce((equipmentList, key) => {
          equipmentList[key] = equipmentItems[key];
          return equipmentList;
        }, {});
      return Object.entries(filteredEquipmentList).map(el => {
        return { name: el[0], total: el[1] };
      });
    }
  },
  methods: {}
};
</script>
